import { FormInputProps } from "_interfaces/_common/forms";
import { RechargeHistoryFilterModel } from "_models/data/recharge/data.recharge-history-filter.model";
import { CustomFilter } from "parts/customFilter";
import React from "react";

interface InputListProps extends FormInputProps {
  name: "dateRange";
}
interface Props {
  filters: RechargeHistoryFilterModel;
  setFilters: React.Dispatch<React.SetStateAction<RechargeHistoryFilterModel>>;
  handleRefresh: () => void;
}

const RechargeHistoryFilter: React.FC<Props> = ({
  filters,
  setFilters,
  handleRefresh,
}) => {
  const inputList: InputListProps[] = [
    {
      type: "dateRange",
      name: "dateRange",
      label: "Date Range",
      placeholder: "Date Range",
    },
  ];

  return (
    <>
      <CustomFilter
        filters={filters}
        setFilters={setFilters}
        filterList={inputList}
        handleRefresh={handleRefresh}
      />
    </>
  );
};

export default RechargeHistoryFilter;
